// Class: openfl.media.ID3Info

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var ID3Info = function() {
}

// Meta

ID3Info.__name__ = "openfl.media.ID3Info";
ID3Info.__isInterface__ = false;
ID3Info.prototype = {
	
};
ID3Info.prototype.__class__ = ID3Info.prototype.constructor = $hxClasses["openfl.media.ID3Info"] = ID3Info;

// Init



// Statics




// Export

exports.default = ID3Info;